import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DashboardContainer from "../containers/Dashboard/Dashboard";

const mapDispatchToProps = dispatch => ({});

const mapStateToProps = state => ({
  loading: state.user.loading,
  user: state.user.value,
  error: state.user.error,
});

const DashboardProvider = withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardContainer));

export default DashboardProvider;
